module.exports = __webpack_public_path__ + "static/media/loginPic.d2bc9c9e.png";